import React, { useEffect, useRef } from 'react';

/**
 * Enhanced Code Editor Component - Displays code with improved formatting
 */
const CodeEditor = ({ 
  value, 
  className = '', 
  language = 'markdown',
  padding = 10,
  readOnly = true,
  style = {}
}) => {
  const codeRef = useRef(null);

  // Format the code with proper spacing and indentation
  const formatCode = () => {
    if (!value) return '';
    
    // Replace spaces at the beginning of lines with non-breaking spaces
    // This preserves indentation when rendered in HTML
    return value
      .split('\n')
      .map(line => {
        // Count leading spaces
        const leadingSpaces = line.match(/^\s*/)[0].length;
        // Replace with non-breaking spaces
        return '\u00A0'.repeat(leadingSpaces) + line.substring(leadingSpaces);
      })
      .join('\n');
  };

  return (
    <pre
      className={`code-editor ${className}`}
      style={{
        padding: `${padding}px`,
        border: '1px solid #e2e8f0',
        borderRadius: '0.375rem',
        background: '#f8fafc',
        overflow: 'auto',
        fontFamily: 'ui-monospace, SFMono-Regular, SF Mono, Consolas, Liberation Mono, Menlo, monospace',
        fontSize: '0.875rem',
        lineHeight: '1.7',
        tabSize: 2,
        whiteSpace: 'pre-wrap',
        ...style
      }}
      ref={codeRef}
    >
      <code 
        className={`language-${language}`}
        style={{
          display: 'block',
          color: '#24292e',
          overflowWrap: 'break-word'
        }}
      >
        {formatCode()}
      </code>
    </pre>
  );
};

export default CodeEditor; 